import { Card } from '@d-edge/overnight-hotelier-react'
import type { CSSProperties, ReactNode } from 'react'
import { Spinner } from './Spinner'
import styles from './ui.module.css'

interface WidgetProps {
  title: ReactNode
  children: ReactNode
  /** Makes the title a button, usually opening a detail dialog. */
  onTitleClick?: () => void
  actions?: ReactNode
  loading?: boolean
  flush?: boolean
  className?: string
  style?: CSSProperties
}

/** Dashboard card with a teal title bar. */
export function Widget({ title, children, onTitleClick, actions, loading, flush, className, style }: WidgetProps) {
  return (
    <Card className={`${styles.widget} ${className ?? ''}`} style={style}>
      <header className={styles.widgetHeader}>
        {onTitleClick ? (
          <button type="button" className={`${styles.widgetTitle} ${styles.widgetTitleButton}`} onClick={onTitleClick}>
            {title}
          </button>
        ) : (
          <h2 className={styles.widgetTitle}>{title}</h2>
        )}
        {loading && <Spinner />}
        {actions && <div className={styles.widgetActions}>{actions}</div>}
      </header>
      <div className={`${styles.widgetBody} ${flush ? styles.widgetBodyFlush : ''}`}>{children}</div>
    </Card>
  )
}
